import React from 'react';
import { LuBrain, LuCircuitBoard  } from "react-icons/lu";

const benefits = [
  { icon: <LuCircuitBoard className="text-blue-600 w-6 h-6" />, title: "Building the Digital Layer Behind Residential Services", desc: "Matanato is developing a centralized digital infrastructure designed to manage and scale home services within modern residential communities. Our platform transforms fragmented service requests into a structured, data-driven system, enabling full visibility, coordination, and control across all in-unit service operations." },
  { icon: <LuBrain className="text-blue-600 w-6 h-6" />, title: "AI-Driven Future", desc: "Matanato is integrating AI-powered tools to enhance both operational performance and resident experience. These technologies are being developed to support: • intelligent request routing and prioritization • predictive maintenance insights • automated customer interaction (chat & voice) • service demand forecasting and analytics" },
];

const IT = () => {
  return (
    <section className="bg-gray-50 my-12 py-10 px-4 md:px-10 rounded-2xl shadow-md max-w-6xl mx-auto"  id="it">
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-10">Technology & Infrastructure. AI Integration</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {benefits.map((item, index) => (
          <div key={index} className="flex items-start space-x-4 p-4 bg-white rounded-xl shadow hover:shadow-md transition">
            <div>{item.icon}</div>
            <div>
              <h4 className="font-semibold text-lg text-gray-800">{item.title}</h4>
              <p className="text-gray-600 text-sm">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default IT;
